import en from './en';

export const pollTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
